import { http } from './index'

export async function getDepartmentTree() {
    return await http.get<any>('/api/departments/tree/')
}

export async function getDepartments(params:any) {
    return await http.get<any>('/api/departments/', {params})
}

export async function getDepartment(id:string) {
    return await http.get<any>(`/api/departments/${id}/`)
}

export async function editDepartment(id:string, data:any) {
    return await http.patch<any>(`/api/departments/${id}/`, data)
}

export async function checkDepartmentRules(id:string, params:any) {
    return await http.get<any>(`/api/departments/${id}/checker/`, {params})
}

export async function getStaff(id:string) {
    return await http.get<any>(`/api/staff-units/${id}/`)
}